import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    navindex: 0,
    language: 'zh-CN'
}

const getters = {
  currentLanguage: state => state.language
}

const actions = {
  initLanguage({ commit }) {
    // 首先检查本地存储
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      commit('setLanguage', savedLanguage);
      return;
    }
    
    // 先根据浏览器语言检测
    const browserLang = detectBrowserLanguage();
    if (browserLang) {
      commit('setLanguage', browserLang);
      localStorage.setItem('language', browserLang);
      return;
    }
    
    // 如果浏览器语言无法确定，则通过IP地理位置检测
    // detectLanguageByIP(commit)
    //   .catch(() => {
    //     // 出错时默认使用中文
    //     commit('setLanguage', 'zh-CN');
    //     localStorage.setItem('language', 'zh-CN');
    //   });
  },
  
  changeLanguage({ commit }, language) {
    commit('setLanguage', language);
    localStorage.setItem('language', language);
  }
}

// 根据浏览器语言检测
function detectBrowserLanguage() {
  const userLang = navigator.language || navigator.userLanguage;
  
  // 除了中文之外的其他语言都默认为英文
  if (userLang && userLang.toLowerCase().startsWith('zh')) {
    return 'zh-CN';
  } else if (userLang) {
    return 'en';
  }
  
  return null;
}

// 通过IP地理位置检测语言
function detectLanguageByIP(commit) {
  return new Promise((resolve, reject) => {
    // 使用免费的ip-api.com服务，无需API密钥，适用于非商业用途
    fetch('http://ip-api.com/json/?fields=status,countryCode')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        if (data.status !== 'success') {
          throw new Error('IP geolocation request failed');
        }
        
        // 根据国家代码确定语言 - 除了中国相关地区外都使用英文
        const chineseCountries = ['CN', 'HK', 'MO', 'TW'];
        const countryCode = data.countryCode;
        const lang = chineseCountries.includes(countryCode) ? 'zh-CN' : 'en';
        
        commit('setLanguage', lang);
        localStorage.setItem('language', lang);
        resolve(lang);
      })
      .catch(error => {
        console.error('Error detecting language by IP:', error);
        reject(error);
      });
  });
}

export default new Vuex.Store({
    state,
    getters,
    mutations: {
        setIndex(state, token) {
            state.navindex = token
        },
        setLanguage(state, language) {
            state.language = language
        }
    },
    actions
})


// WEBPACK FOOTER //
// ./src/store/index.js